export class CustomerPolicy {

  orgUnitId!: string;
  customerId!: string;
  customerName!: string;
  active!: boolean;
  approvedAmount!: number;
  createTimestamp!: Date;
  createUser!: string;
  creditApprovalStatusCode!: string;
  creditCheckAtContractConfirm!: boolean;
  creditHold!: boolean;
  creditLimit!: number;
  currentBalance!: number;
  customerCreditCheckMethodCode!: string;
  defaultArGlAccountId!: string;
  defaultCreditLevelCheckingCode!: string;
  defaultPerOrderCreditLimit!: number;
  updateTimestamp!: Date;
  updateUser!: string;

}
